export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11915.b110856d.jpg";